<template>
  <el-container>
    <el-aside>
      <SiderMenu />
    </el-aside>
    <el-container class='mars-ape-layout' :class='`${$route.name}_mars-ape-layout`'>
      <el-header>
        <Header ref='refHeader' :helpShow.sync='helpShow' />
      </el-header>
      <el-main :class='`${$route.name}_main`'>
        <div style='display: flex; flex-direction: column' :class='`${$route.name}_main-inner`'>
          <div v-if='isRootRoutePath'>
            <div class='mod-index'>
              <HomeIndex></HomeIndex>
            </div>
          </div>
          <router-view :class='`${$route.name}_main-inner__content`' />
        </div>
        <PageOnlineStat />
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import SiderMenu from './SiderMenu'
import Header from './Header'
import HomeIndex from '@/pages/home/HomeIndex'
import PageOnlineStat from '@/components/PageOnlineStat'
import { syncFeishuBadge } from '@/utils/feishu'

export default {
  name: 'BasicLayout',
  components: {
    HomeIndex,
    SiderMenu,
    Header,
    PageOnlineStat
  },
  data() {
    return {
      helpShow: false
    }
  },

  computed: {
    isRootRoutePath: function() {
      return this.$route.path === '/'
    }
  },
  mounted() {},
  methods: {},
  created() {
    this.$globalWs.connection()
    // [OA-星象仪角标同步] 打开星象仪页面时，若处于飞书环境，实时取当前用户待办数并同步到两个 appid（异步、不阻断）
    syncFeishuBadge()
  },
  activated() {
    // console.log('activated')
    this.$globalWs.connection()
  },
  deactivated() {
    // console.log('deactivated')
    this.$globalWs.close()
  },

  beforeDestroy() {
    // console.log('beforeDestroy')
    this.$globalWs.close()
  },
  destroyed() {
    // console.log('destroyed')
  }
}
</script>
<style scoped>
.mod-index {
  border-radius: 5px;
  background: #fff;
  padding: 20px;
  min-height: 800px;
  line-height: 1.5;
}

.mod-index p {
  margin: 0;
}

.mod-index h3 {
  margin-block-start: 0;
  margin-block-end: 0.5em;
}

.mod-index .xm-gt img {
  height: 240px;
  margin-left: -16px;
}

.mod-index .jx-zz img {
  height: 400px;
  margin-top: 24px;
  margin-right: 24px;
}

.el-container {
  background: #f0f2f5;
}

.el-aside {
  height: 100vh;
  position: sticky;
  top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.08);
  width: auto !important;
  z-index: 10;
  transition: all 0.3s;
  background: #fff;
}

.el-header {
  height: 66px !important;
  padding: 0;
  width: 100%;
  /* border: 1px solid red; */
  box-shadow: 0 2px 8px #f2f3f5 !important;
  /* margin-bottom: 0px; */
}

.el-main {
  padding: 0;
  /* margin: 6px 4px; */
  overflow: inherit;
  /* flex: none !important;*/
}

/* min-height: 720px; */

.main-page-content {
  /* border-radius: 5px; */
  /* background: #ffffff; */
}

/* padding: 8px 10px 0 10px; */

.el-footer {
  height: auto !important;
}
</style>
<style lang='scss' scoped>
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  //width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}
</style>
<style lang='scss'>
.main-page-content {
  padding: 4px 8px;

  > *:not(.secondary-nav,button,.ape-drawer,.el-drawer) {
    background-color: #FFFFFF;
    padding: 8px 10px 0 10px;
  }
}
</style>
